export enum EEmployeeType {
  FULL_TIME = 'full_time',
  PART_TIME = 'part_time',
}
